import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { EditorSection, sectionDisplayName } from "./sectionUtils";

// Issue 41.8: the confirm-and-remove flow shared by the Manage Sections modal and the direct
// "Remove this section" control in the section bar.
type Props = {
  section: EditorSection | null;
  index: number | null;
  onCancel: () => void;
  onConfirm: (index: number) => void;
};

const QuoteRemoveSectionDialog = ({ section, index, onCancel, onConfirm }: Props) =>
  <Dialog open={section != null} onClose={onCancel} maxWidth="xs">
    <DialogTitle>Remove {section && index != null ? sectionDisplayName(section.name, index) : ""}?</DialogTitle>
    <DialogContent>
      <Typography>Its {section?.items.length || 0} line item{section?.items.length === 1 ? "" : "s"} will be deleted from this quote.</Typography>
    </DialogContent>
    <DialogActions className="quote-remove-section-dialog-actions">
      <Button color="inherit" onClick={onCancel}>Cancel</Button>
      <Button color="error" variant="contained" onClick={() => index != null && onConfirm(index)}>Remove Section</Button>
    </DialogActions>
  </Dialog>;

export default QuoteRemoveSectionDialog;
